import { render, staticRenderFns } from "./Erp6PurchaseOrderEdit.vue?vue&type=template&id=45448506&scoped=true&"
import script from "./Erp6PurchaseOrderEdit.vue?vue&type=script&lang=js&"
export * from "./Erp6PurchaseOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./Erp6PurchaseOrderEdit.vue?vue&type=style&index=0&id=45448506&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45448506",
  null
  
)

export default component.exports